import { IImageUpload } from '@common/types/element';
import { pick } from 'lodash';
import { StyleSheet } from 'react-native';
import { useSelector } from 'react-redux';

import { appInfoSelector } from '@common/redux/selectors/app';
import { AppVersion } from 'click-types';

const createStyles = (attributes: IImageUpload) => {
  const appInfo = useSelector(appInfoSelector);
  const isV4 = appInfo?.version === AppVersion.V4;
  const style = attributes.style || {};

  return StyleSheet.create({
    innerWrapper: {
      ...pick(attributes, [
        'opacity',
        'width',
        'height',
        'marginTop',
        'marginLeft',
        'borderRadius',
      ]),
      ...pick(attributes, ['borderWidth', 'borderColor']),
      overflow: 'hidden',
      ...(style?.marginRight !== undefined && {
        marginRight: style.marginRight,
      }),
      ...(style?.marginBottom !== undefined && {
        marginBottom: style.marginBottom,
      }),
      ...(style?.margin !== undefined && {
        margin: style.margin,
      }),
      zIndex: attributes.zIndex,
      borderStyle:
        attributes?.borderStyle === 'none' ? 'solid' : attributes.borderStyle,
      borderWidth:
        attributes?.borderStyle === 'none' ? 0 : attributes.borderWidth,
      opacity: attributes?.style?.opacity ?? 1,
      ...(isV4 &&
        pick(style, [
          'top',
          'left',
          'bottom',
          'right',
          'position',
          'transform',
        ])),
    },
    preview: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#eee',
      borderRadius: attributes.borderRadius,
      overflow: 'hidden',
    },
  });
};
export default createStyles;

export const staticStyles = StyleSheet.create({
  text: {
    fontSize: 14,
    color: '#6C777C',
    fontFamily: 'Roboto',
  },
  previewImage: {
    position: 'absolute',
    width: '100%',
    height: '100%',
  },
  faded: {
    opacity: 0.5,
  },
  icon: {
    opacity: 0.2,
    width: 40,
    height: 30,
  },
  emptyWrapper: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  selectImage: {
    color: 'orange',
    fontWeight: '500',
    fontSize: 14,
  },
  selectAnother: {
    marginTop: 8,
    alignItems: 'center',
    position: 'absolute',
    zIndex: 99,
    justifyContent: 'center',
    alignSelf: 'center',
  },
  image: {
    width: '100%',
    height: '100%',
  },
  modalWrapper: {
    position: 'absolute',
    bottom: 26,
    right: 0,
    left: 0,
    width: '100%',
    padding: '2%',
  },
  contentModalWrapper: {
    overflow: 'hidden',
    borderRadius: 10,
  },
  select: {
    height: 50,
    backgroundColor: '#f1f1f1',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  labelModal: {
    color: '#3f7aff',
    fontWeight: 'bold',
    fontSize: 18,
  },
});
